{
	"title": "Carbon Bank balance",
	"adjust": "Adjust",
	"co2Unit": "kg CO₂",
	"chartUnit": "t",
	"chartAriaLabel": "Monthly carbon bank balance chart",
	"emptyState": "No balance data available for the selected year.",
	"series": {
		"fossil": "Carbon origin: fossil",
		"biogenic": "Carbon origin: biogenic",
		"totalCarbon": "Total Carbon Bank balance",
		"buffer": "Carbon buffer volume"
	},
	"stats": {
		"balance": "Current total Carbon Bank balance",
		"deposits": "Total deposits",
		"withdrawals": "Total withdrawals"
	},
	"months": {
		"jan": "Jan",
		"feb": "Feb",
		"mar": "Mar",
		"apr": "Apr",
		"may": "May",
		"jun": "Jun",
		"jul": "Jul",
		"aug": "Aug",
		"sep": "Sep",
		"oct": "Oct",
		"nov": "Nov",
		"dec": "Dec"
	}
}
